import { components } from "../../services/api/banking/types";

export const selectorTaxWithholdingAccount = (
  internalAccount: components["schemas"]["InternalAccount"]
) =>
  internalAccount.type === "TaxWithholding" &&
  (internalAccount.status === "Active" || internalAccount.status === "Pending");
